import React from "react";
import Button from "react-bootstrap/Button";
import company from "../../assets/images/devdetail/company.png";
import star from "../../assets/images/devdetail/star.svg";
import folio1 from "../../assets/images/devdetail/folio1.png";
import folio2 from "../../assets/images/devdetail/folio2.png";
import { Link } from "react-router-dom";

const DevDetail = () => {
  // const skilldata = [
  //   "REST",
  //   "Kotlin",
  //   "Java",
  //   "Android SDK",
  //   "Material Design",
  //   "Websockets",
  //   "Firebase",
  //   "Android App Development",
  //   "Mobile UI Design",
  //   "Google Maps API",
  //   "Android NDK",
  //   "In-App Purchases",
  //   "SQLite",
  //   "GraphQL",
  //   "Mobile App Development",
  // ];

  const list1 = [
    "Mobile UI Design",
    "Android App Development",
    "Google Maps API",
    "Mobile App Development",
    "GraphQL",
  ];

  const list2 = [
    "Android NDK",
    "Kotlin",
    "Java",
    "Material Design",
    "In-App Purchases",
  ];

  const historyData = [
    {
      tittle: "Android developer for messenger app with blockchain",
      img: star,
      rating: "5.0",
      date: "Jan 10, 2022 - Feb 23, 2022",
      comment:
        "Artem is a hard-working perfectionist who is always ready to put all his energy into the current project in the fast-paced product cycle. He is a world-class and highly motivated software engineer with strong technical skills. It was really productive and inspiring to work with him. I definitely would want to work with him again later.",
    },
    {
      tittle: "Android developer for messenger app with blockchain",
      img: star,
      rating: "5.0",
      date: "Jan 10, 2022 - Feb 23, 2022",
      comment:
        "Artem is a hard-working perfectionist who is always ready to put all his energy into the current project in the fast-paced product cycle. He is a world-class and highly motivated software engineer with strong technical skills. It was really productive and inspiring to work with him. I definitely would want to work with him again later.",
    },
    {
      tittle: "Android developer for messenger app with blockchain",
      img: star,
      rating: "5.0",
      date: "Jan 10, 2022 - Feb 23, 2022",
      comment:
        "Artem is a hard-working perfectionist who is always ready to put all his energy into the current project in the fast-paced product cycle. He is a world-class and highly motivated software engineer with strong technical skills. It was really productive and inspiring to work with him. I definitely would want to work with him again later.",
    },
  ];

  const folioData = [
    {
      img: folio1,
      title: "Blockchain Wallet App on Android",
    },
    {
      img: folio2,
      title: "Taxi App on Android",
    },
  ];

  return (
    <div className='dev-content-detail'>
      <div className='dev-detail-box'>
        <div className='dev-detail-box-list'>
          <h3 id='Agency'>Agency</h3>
          <img src={company} alt='company' />
          <h3 className='dev-details-skill-h3' id='Skills'>
            Skills
          </h3>
          <div className='dev-detail-skill-list'>
            <div className='dev-detail-skill-data'>
              {list1.map((item, i) => {
                return <p>{item}</p>;
              })}
            </div>
            <div className='dev-detail-skill-data'>
              {list2.map((item, i) => {
                return <p>{item}</p>;
              })}
            </div>
            {/* {skilldata.map((e, i) => (
              <span key={i}>{e}</span>
            ))} */}
          </div>
          <button className='dev-detail-skill-btn'>Show All</button>
        </div>
      </div>
      <div className='dev-detail-box'>
        <h3 id='Highlights'>Highlights</h3>
        <div className='dev-detail-box-highlight'>
          <ul>
            <li>English: Fluent</li>
            <li>20+ released projects</li>
            <li>7+ years of Android development experience</li>
            <li>Experienced Android Developer</li>
          </ul>
        </div>
        <p>
          I've been developing high-quality mobile apps for more than 7 years
          now. I've been working on a broad variety of projects: mobile banking
          apps, mobile clients for enterprise systems, educational and
          entertaining apps, b2b and b2c projects. I've worked with applications
          requiring different technologies and skills. I especially want to note
          the experience of fixing errors made by previous developers.
        </p>
      </div>
      <div className='dev-detail-box'>
        <h3 id='Language'>Preferred Language</h3>
        <span className='dev-detail-box-eng'>English</span>
      </div>
      <div className='dev-detail-box'>
        <h3 id='History'>Work History</h3>
        {historyData.map((e, i) => (
          <div className='dev-detail-history' key={i}>
            <h4>{e.tittle}</h4>
            <div className='dev-detail-history-rating'>
              <div className='dev-history-rating'>
                <img src={e.img} alt='star' />
                <span>{e.rating}</span>
              </div>
              <p>{e.date}</p>
            </div>
            <div className='dev-detail-comment'>
              <p>{e.comment}</p>
            </div>
          </div>
        ))}
      </div>
      <div className=' dev-detail-portfolio'>
        <h3 id='Portfolio'>Portfolio</h3>
        <div className='dev-portfolio-grid'>
          {folioData.map((e, i) => (
            <Link to='/'>
              <div className='dev-portfolio-box' key={i}>
                <img src={e.img} alt='folio' />
                <h4>{e.title}</h4>
              </div>
            </Link>
          ))}
          <div className='dev-portfolio-box-sighup'>
            <h4>Want to see more?</h4>
            <Button className='light-bg-btn'>Sign Up</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevDetail;
